import './quote-slider.scss'
import { Swiper, Pagination, Autoplay, Navigation } from 'swiper'

const init = () => {
  Swiper.use([Autoplay, Pagination, Navigation])

  const isSlider = document.querySelectorAll('.quote-slider__slider .swiper-slide')?.length > 1

  new Swiper('.quote-slider__slider', {
    slidesPerView: 'auto',
    autoHeight: true,
    spaceBetween: 32,
    simulateTouch: false,
    loop: isSlider,

    autoplay: {
      enabled: isSlider,
      delay: 10000,
      disableOnInteraction: false,
    },

    navigation: {
      prevEl: '.quote-slider__slider .prev',
      nextEl: '.quote-slider__slider .next',
    },

    pagination: {
      el: '.quote-slider__navigation',
      clickable: true,

      renderBullet: function (index, className) {
        const slide_logo = this.el.dataset.pagination.split(',') || []

        return `<div class="slider-tab ${className}">
          <img src="${slide_logo[index]}" alt="">
        </div>`
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  init()
})
